import { createSlice } from "@reduxjs/toolkit";
import { CONNECTORS } from "../../../constants/reducer_names";



const initialState: any = {
    tempApiList: [],
    crmModuleList: [],
    crmApiDetails: [],
    crmSubModuleList: [],
    tempCrmModulelist: [],
    tempSubModulelist: [],
    configConnectorList: [],
    tempSalesforceProp: [],
    syncDetails: {},
    storeDetails: {},
    syncContactData:[],
    connectorsData:{},
    connectorCompanyData:{},
    refereshToken:{},
    allPaymentmethoad:[],
    isNewContactsAdded : false,
    dynamicsToken : "",
    xeroToken : ""
} as any;

const connectorSlice = createSlice({
    name: CONNECTORS,
    initialState,
    reducers: {
        setModuleList: (state, { payload }) => {
            state.crmModuleList = payload.crmModuleList
        },

        setSubModuleList: (state, { payload }) => {
            state.crmSubModuleList = payload.crmSubModuleList
        },

        setCrmApiDetails: (state, { payload }) => {
            state.crmApiDetails = payload.crmApiDetails
        },
        setTempModuleList: (state, { payload }) => {
            state.tempCrmModulelist = payload.tempCrmModulelist
        },

        setTempSubModuleList: (state, { payload }) => {
            state.tempSubModulelist = payload.tempSubModulelist
        },

        setTempApiList: (state, { payload }) => {
            state.tempApilist = payload.tempApilist
        },

        SetConfigConnectorList: (state, { payload }) => {
            state.configConnectorList = payload.configConnectorList
        },
        
        SetTempSalesforceProp: (state, { payload }) => {
            state.tempSalesforceProp = payload.tempSalesforceProp
        },
        setSyncDetails: (state, { payload }) => {
            state.syncDetails = payload.syncDetails
        },
        setStoreDetails: (state, { payload }) => {
            // console.log('payload storeDetais ==> ',payload)
            state.storeDetails = payload
            // console.log('payload state.storeDetails ==> ',state.storeDetails)
        },
        setSyncContactDetails: (state, { payload }) => {
            state.syncContactData = payload
        },
        setConnectorsData: (state, { payload }) => {
            state.connectorsData = payload
        },
        setConnectorCompanyData: (state, { payload }) => {
            state.connectorCompanyData = payload
        },
        setRefereshToken: (state, { payload }) => {
            state.refereshToken = payload
        },
        allPaymentmethoad : (state, { payload }) => {
            state.allPaymentmethoad = payload
        },
        setNewContactAdd : (state, { payload }) => {
            state.isNewContactsAdded = payload
        },
        setDynamicsToken : (state, { payload }) => {
            state.dynamicsToken = payload
        },
        setXeroToken : (state, { payload }) => {
            state.xeroToken = payload
        },

    }
});


export const connectorsActions = connectorSlice.actions;
export default connectorSlice.reducer;



